module.exports = __webpack_public_path__ + "a9c79eb3.png";